module.exports = __webpack_public_path__ + "img/roll-bg.84f40a7e.svg";